export default __webpack_public_path__ + "static/media/edit.8f6fdd24.png";